import React from "react";
import { UserIcon } from "@heroicons/react/24/solid";

interface Props {
    residentName: string
}

const Resident = ({ residentName }: Props) => {

    return (
        <div className="flex flex-row rounded-lg bg-sb-bg w-full p-3 text-xl font-bold justify-between">
            <div className="mt-auto">{residentName}</div>
            <div><UserIcon width={30} className="inline-block text-blue-800" /></div>
        </div>
    );
}

export default Resident;